
import { Component, OnInit, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatTabsModule } from '@angular/material/tabs';
import { MatIcon } from '@angular/material/icon';

@Component({
  selector: 'app-carousel',
  standalone: true,
  imports: [CommonModule, MatTabsModule,MatIcon],
  templateUrl: './carousel.component.html',
  styleUrls: ['./carousel.component.css'],

})
export class CarouselComponent implements OnInit, OnDestroy {
  // images = [
  //   'assets/images/wedp.jpeg',
  //   'assets/images/main3.jpeg',
  //   'assets/images/bparty.jpeg'
  // ];

  images = [

    { src: 'assets/images/IMG_1977.JPG', title: 'Be it the blissful anniversaries' },
    { src: 'assets/images/IMG_1981.JPG', title: 'Or be it the romantic wedding' },
    { src: 'assets/images/IMG_1982.JPG', title: 'Be it the blissful anniversaries' },
    { src: 'assets/images/IMG_1984.JPG', title: 'Or be it the romantic wedding' },
    { src: 'assets/images/IMG_2029.JPG', title: 'Be it the blissful anniversaries' },
    { src: 'assets/images/IMG_2030.JPG', title: 'Or be it the romantic wedding' },
    { src: 'assets/images/IMG_2044.JPG', title: 'Be it the blissful anniversaries' },
    { src: 'assets/images/IMG_2052.JPG', title: 'Or be it the romantic wedding' },
    { src: 'assets/images/IMG_2057.JPG', title: 'Be it the blissful anniversaries' },
    { src: 'assets/images/IMG_2083.JPG', title: 'Or be it the romantic wedding' },
    { src: 'assets/images/IMG_2088.JPG', title: 'Be it the blissful anniversaries' },
    { src: 'assets/images/IMG_2093.JPG', title: 'Or be it the romantic wedding' },
    { src: 'assets/images/IMG_2094.JPG', title: 'Be it the blissful anniversaries' },
    { src: 'assets/images/IMG_2095.JPG', title: 'Or be it the romantic wedding' },
    { src: 'assets/images/IMG_2096.JPG', title: 'Be it the blissful anniversaries' },
    { src: 'assets/images/IMG_2097.JPG', title: 'Or be it the romantic wedding' },
    { src: 'assets/images/IMG_2098.JPG', title: 'Be it the blissful anniversaries' },
    { src: 'assets/images/IMG_2100.JPG', title: 'Or be it the romantic wedding' },
    { src: 'assets/images/IMG_2109.JPG', title: 'Be it the blissful anniversaries' },
    { src: 'assets/images/IMG_2113.JPG', title: 'Or be it the romantic wedding' },
    { src: 'assets/images/IMG_2116.JPG', title: 'Be it the blissful anniversaries' },
    { src: 'assets/images/IMG_2118.JPG', title: 'Or be it the romantic wedding' },
    { src: 'assets/images/IMG_2135.JPG', title: 'Be it the blissful anniversaries' },
    { src: 'assets/images/IMG_2201.JPG', title: 'Be it the blissful anniversaries' },
    { src: 'assets/images/IMG_2212.JPG', title: 'Be it the blissful anniversaries' },
    { src: 'assets/images/IMG_2216.JPG', title: 'Be it the blissful anniversaries' },
    { src: 'assets/images/IMG_2220.JPG', title: 'Be it the blissful anniversaries' },
    { src: 'assets/images/IMG_2221.JPG', title: 'Be it the blissful anniversaries' },
    { src: 'assets/images/IMG_2224.JPG', title: 'Be it the blissful anniversaries' }


  ];

  selectedIndex = 0;
  intervalId: any;

  ngOnInit(): void {
    //alert("I am here");
    // this.startSlideshow();

    setInterval(() => this.nextImage(), 3000); // Change image every 3 seconds

  }

  ngOnDestroy(): void {
    this.stopSlideshow();
  }

  startSlideshow(): void {
    this.intervalId = setInterval(() => {
      this.selectedIndex = (this.selectedIndex + 1) % this.images.length;
    }, 3000); // Change the slide every 3 seconds
  }

  stopSlideshow(): void {
    if (this.intervalId) {
      clearInterval(this.intervalId);
    }
  }

  isCurrentTab(image: { src: string; title: string }): boolean {
    return this.images[this.selectedIndex] === image;
  }

  nextImage() {
    this.selectedIndex = (this.selectedIndex + 1) % this.images.length;
  }
  prevImage() {
    this.selectedIndex = (this.selectedIndex - 1 + this.images.length) % this.images.length;
  }
}